export const BTC_ORANGE = '#FF9900';
export const MINING_RED = '#FF0000';
export const RATIO_BLUE = 'rgba(6, 0, 188, 0.25)';
export const DEFAULT_DOLLAR_PER_KWH = 0.06;
